import type { Plan, Product } from '@vy/types';
import { isUsageProduct } from '@vy/services';
import { isNullOrUndefined } from '@vy/utils';
import {
  PRO_RATA_SETTINGS,
  type ProRataSettings,
} from '../pages/plans/CreatePlanPage/create-plan-page-components/CreatePlanForm/create-plan-form-types/create-plan-form-sub-types';

export function getProRataSetting(plan: Plan): ProRataSettings {
  const proRated = plan.billingData.proRated;

  if (isNullOrUndefined(proRated)) {
    return deriveProRataSettingFromProducts(plan.products);
  }

  if (proRated) {
    return PRO_RATA_SETTINGS.PRO_RATA_AND_CALENDAR_ALIGNED;
  }

  return deriveProRataSettingFromProducts(plan.products);
}

function deriveProRataSettingFromProducts(products: Product[]): ProRataSettings {
  const product = products.find(isUsageProduct) ?? products[0];

  if (!product) {
    return PRO_RATA_SETTINGS.PRO_RATA_AND_CALENDAR_ALIGNED;
  }

  if (product.isCalendarAligned) {
    return PRO_RATA_SETTINGS.PRO_RATA_AND_CALENDAR_ALIGNED;
  }

  if (product.proRata) {
    return PRO_RATA_SETTINGS.PRO_RATA;
  }

  return PRO_RATA_SETTINGS.DISABLED;
}
